export default __webpack_public_path__ + "static/media/Tecnologia_potencia_ntorq_125.0a1fb5a1.jpg";